export default {
  install (Vue, store, types) {
    if (!store) {
      return false
    }

    const hasPermission = permission => {
      const permissions = store.getters[types.COMPANY_PERMISSIONS] || []
      return permissions.some((v) => v === permission)
    }

    Object.defineProperty(Vue.prototype, '$can', {
      get () {
        return hasPermission
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/can.js